// コメント以下は、hsbによる値
// whiteは #FFFFFF をその場その場で書き込むこと

export const logoColor = {
  starbucks: "#00704A",
  doutor: "#FEB403",
  excel: "#409FD9",
  excel_barista: "#B0E0E6",
  veloce: "#A03136",
  tullys: "#d92704"
}

export const Black = {
  strong: "#1A1A1A", // 0,0,10
  normal: "#333333", // 0,0,20
  light: "#4D4D4D", // 0,0,30
}

export const Brown = {
  dark: "#50443C", // 23,25,32
  normal: "#755A49", // 23,38,46
  strong: "#60493B", // 23,39,38
  light: "#89807A", // 23,11,54
}



// WEBPACK FOOTER //
// ./src/styles/colors.js